import React from 'react'


export const GetDateNow = () => {

  var today = new Date();
  var dd = today.getDate();
  var mm = today.getMonth() + 1;
  var yyyy = today.getFullYear();

  if (dd < 10) dd = '0' + dd
  if (mm < 10) mm = '0' + mm

  today = dd + '/' + mm + '/' + yyyy;

  return today;
}


export const FormatDate = (d) => {

  if (d === '' || d === null || typeof d === 'undefined') {
    return '';
  }
  else {
    let date; //Replaces whitespace with T to conform with ISO 8601 for safari compatability
    if (d) {
      date = new Date(d.replace(/\s/, 'T'))
    } else {
      date = new Date(d);
    }
    let dd = date.getDate();
    let mm = date.getMonth() + 1;
    let yyyy = date.getFullYear();

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;

    return dd + '/' + mm + '/' + yyyy;
  }

}


export const FormatDateTime = (d) => {

  if (d === '' || d === null || typeof d === 'undefined') {
    return '';
  }
  else {
    let date = new Date(d.replace(/\s/, 'T')); //Replaces whitespace with T to conform with ISO 8601 for safari compatability
    let dd = date.getDate();
    let mm = date.getMonth() + 1;
    let yyyy = date.getFullYear();
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let seconds = date.getSeconds();

    minutes = minutes < 10 ? '0' + minutes : minutes;
    seconds = seconds < 10 ? '0' + seconds : seconds;

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;

    return dd + '/' + mm + '/' + yyyy + ' ' + hours + ':' + minutes + ':' + seconds;
  }

}


export const FormatDateDocument = (d) => {

  if (d === '' || d === null) {
    return '';
  }
  else {
    let date = d.split('-');

    return date[2] + '/' + date[1] + '/' + date[0];
  }

}


export const ConvertToBool = (value) => {

  if (value === '' || value === null || typeof value === 'undefined') {
    return false;
  }
  else {
    return value === 'yes' ? true : false;
  }

}


export const ConvertDeletedToBool = (value) => {

  if (value === '' || value === null || typeof value === 'undefined') {
    return false;
  }
  else {
    return value === 'yes' ? false : true;
  }

}


export const ConvertFromBool = (bool) => {

  if (bool === '' || bool === null || typeof bool === 'undefined') {
    return 'no';
  }
  else {
    return bool === true ? 'yes' : 'no';
  }

}


export const ConvertDeletedFromBool = (bool) => {

  if (bool === '' || bool === null || typeof bool === 'undefined') {
    return 'no';
  }
  else {
    return bool === false ? 'yes' : 'no';
  }

}


export const ConvertEmptyDateString = (dateString) => {

  if (dateString === '' || dateString === null || typeof dateString === 'undefined') {
    return '';
  }
  else {
    return dateString === '01/01/0001' ? '' : FormatDate(dateString);
  }

}


export const StringAllOptionals = (negotiatedOptionals, announcedOptionals, props) => {
  const { classes } = props;

  let i = 0;
  let optionalsHTML = [];
  var obj = {};

  for (i = 0; i < negotiatedOptionals.length; i++) {
    obj[negotiatedOptionals[i]] !== undefined ? obj[negotiatedOptionals[i]]++ : obj[negotiatedOptionals[i]] = 1;
  }
  for (i = 0; i < announcedOptionals.length; i++) {
    obj[announcedOptionals[i]] !== undefined ? obj[announcedOptionals[i]]-- : obj[announcedOptionals[i]] = -1;
  }

  let total = Object.keys(obj).length;
  i = 0;
  let keyE = 0;
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      switch (obj[key]) {
        case 0:
          optionalsHTML.push(
            <React.Fragment key={keyE}>
              <span className={classes.textAquaBlue}>{key}</span>
            </React.Fragment>
          );
          break;
        case 1:
          optionalsHTML.push(
            <React.Fragment key={keyE}>
              <span className={classes.textGrassGreen}>{key}</span>
            </React.Fragment>
          );
          break;
        case -1:
        default:
          optionalsHTML.push(
            <React.Fragment key={keyE}>
              <span>{key}</span>
            </React.Fragment>
          );
          break;
      }
      keyE++;
      if (i < total - 1) {
        optionalsHTML.push(<React.Fragment key={keyE}>&nbsp;||&nbsp;</React.Fragment>);
        keyE++;
      }

    }
    i++;
  }

  return optionalsHTML;
}


// WEBPACK FOOTER //
// ./src/components/Utils/GenericFunctions.js